import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthUserService } from '../../../core/services/auth-user.service';

@Component({
  selector: 'app-client-page',
  templateUrl: './client-page.component.html',
  styleUrls: ['./client-page.component.css']
})
export class ClientPageComponent implements OnInit {
  isAdmin: boolean = parseInt(localStorage.getItem('role')) ==1 ? true : false;
  inspection;
  isClientPage = false;
  public isCollapsed = true;
  constructor(private authUserService: AuthUserService, private router: Router) { }

  ngOnInit(): void {
    if (this.router.url.includes('client')) {
      this.isClientPage = true;
    }
  }

  get isInspection() {
    if (this.router.url.includes('/twoeightone/inspection') || this.router.url.includes('/superdry/inspection')) {
      this.inspection = true;
    } else {
      this.inspection = false;
    }
    return this.inspection;
  }
  /**
     * Function for logout admin
     */
  logout() {
    this.authUserService.logout();
  }
}
